import Config from '../Config';
import moment from 'moment';
import {format, format_without_time} from '../Utils';
import { RestService } from './RestService';

export const DeliveryService = {
    getDeliverySchedule: async function(date, from = 0, offset = 20){
        return RestService.get(`${Config.get_store_delivery_schedule}date=${moment(date).format(format)}&from=${from}&offset=${offset}`, {})
        .then(response => response.json());
    },
    getCustomerDeliverySchedule: async function(date, from = 0, offset = 20){
        return RestService.get(`${Config.get_customer_delivery_schedule}date=${moment(date).format(format)}&from=${from}&offset=${offset}`, {})
        .then(response => response.json());
    },
    getStoreDeliveries: async function(store, startdate, enddate, from = 0, offset = 20){
        return RestService.get(`${Config.get_store_deliveries}store_id=${store}&startdate=${moment(startdate).format(format)}&enddate=${moment(enddate).format(format)}&from=${from}&offset=${offset}`, {})
        .then(response => response.json());
    },
    getCustomerDeliveries: async function(id, startdate, enddate, from = 0, offset = 20){
        return RestService.get(`${Config.get_customer_deliveries}id=${id}&startdate=${moment(startdate).format(format)}&enddate=${moment(enddate).format(format)}&from=${from}&offset=${offset}`, {})
        .then(response => response.json());
    },
    getTotalDeliveryScheduleCount: async function(date) {
        return RestService.get(`${Config.total_count}date=${moment(date).format(format)}&data_type=DELIVERY`, {})
        .then(response => response.json());
    },
    getTotalCustomerDeliveryScheduleCount: async function(date) {
        return RestService.get(`${Config.total_count}date=${moment(date).format(format)}&data_type=CUSTOMERS_DELIVERY`, {})
        .then(response => response.json());
    },
    getTotalDeliveryCountForStore: async function(store, startdate, enddate) {
        return RestService.get(`${Config.total_count}store_id=${store}&startdate=${moment(startdate).format(format)}&enddate=${moment(enddate).format(format)}&data_type=STORE_DELIVERY`, {})
        .then(response => response.json());
    },
    getTotalDeliveryCountForCustomer: async function(id, startdate, enddate) {
        return RestService.get(`${Config.total_count}id=${id}&startdate=${moment(startdate).format(format)}&enddate=${moment(enddate).format(format)}&data_type=CUSTOMER_DELIVERY`, {})
        .then(response => response.json());
    },
    getDeliveryPendingApproval: async function(start, numberItems, store_id, startdate, enddate){
        return RestService.get(`${Config.get_store_delivery_pending_approval}from=${start}&offset=${numberItems}${store_id && store_id.length > 0 ? `&store_id=${store_id}` : ''}${ startdate ? `&startdate=${startdate}` : ''}${ enddate ? `&enddate=${enddate}` : ''}`, {})
        .then(response => response.json());
    },
    getTotalCountPendingApproval: async function(store_id, startdate, enddate) {
        return RestService.get(`${Config.total_count}data_type=PA${store_id && store_id.length > 0 ? `&store_id=${store_id}` : ''}${ startdate ? `&startdate=${startdate}` : ''}${ enddate ? `&enddate=${enddate}` : ''}`, {})
        .then(response => response.json());
    },
    getDeliveryScheduleForCalendar: async function(type, fromDate, toDate){
        return RestService.get(`${Config.get_store_delivery_schedule_marker}type=${type}&from_date=${moment.utc(fromDate).format(format_without_time)}&to_date=${moment.utc(toDate).format(format_without_time)}`, {})
        .then(response => response.json());
    },
    createDelivery: async function(body, headers = {}){
        return RestService.post(`${Config.create_delivery}`, headers, body)
        .then(response => response.json());
    },
    removeDelivery:  async function(body, headers = {}){
        return RestService.post(`${Config.remove_delivery}`, headers, body)
        .then(response => response.json());
    },
    resendInvoice:  async function(body, type){
        return RestService.post(`${Config.resend_invoice}type=${type}`, {}, body)
        .then(response => response.json());
    },
    resendCreditNote:  async function(body, type){
        return RestService.post(`${Config.resend_credit_note}type=${type}`, {}, body)
        .then(response => response.json());
    },
    markDelivery: async function(agent_id, body) {
        return RestService.post(`${Config.mark_delivery}agent_id=${agent_id}`, {}, body);
    },
    markDeliveryV2: async function(agent_id, headers = {}, body) {
        return RestService.post(`${Config.mark_delivery_v2}agent_id=${agent_id}`, headers, body)
        .then(response => response.json());
    },
    approveDeliveryChange: async function(body, headers = {}) {
        return RestService.post(`${Config.approve_delivery_change}`, headers, body)
        .then(response => response.json());
    },
    getTotalInvoices: async function(startdate, enddate) {
        return RestService.get(`${Config.total_count}data_type=INVOICE&startdate=${moment(startdate).format(format_without_time)}&enddate=${moment(enddate).format(format_without_time)}`, {})
        .then(response => response.json());
    },
    getInvoices: async function(startdate, enddate, from = 0, offset = 20, option = 'all') {
        return RestService.get(`${Config.list_invoice_details}startdate=${moment(startdate).format(format_without_time)}&enddate=${moment(enddate).format(format_without_time)}&from=${from}&offset=${offset}&option=${option}`, {})
        .then(response => response.json());
    },
    getIndent: async function(date){
        return RestService.get(`${Config.get_indent}date=${moment(date).format(format_without_time)}`, {})
        .then(response => response.json());
    },
    getInactiveStoresByOrder: async function(){
        return RestService.get(`${Config.report_stores_inactive_by_orders}`, {})
        .then(response => response.json());
    },
    getStoresWhoHaventPlacedOrders: async function(){
        return RestService.get(`${Config.report_stores_no_orders}`, {})
        .then(response => response.json());
    },
    getStoresWithNoRecentOrders: async function(days = 7){
        return RestService.get(`${Config.report_stores_with_no_recent_orders}days=${days}`, {})
        .then(response => response.json());
    },
    getUnattendedStoresList: async function(date) {
        return RestService.get(`${Config.get_unattended_stores}date=${date.format(format_without_time)}`, {})
        .then(response => response.json());
    },
    getStoreDeliveryStatus: async function(date) {
        return RestService.get(`${Config.store_delivery_status}schedule_date=${date.format(format_without_time)}`, {})
        .then(response => response.json());
    },
    getStoreShelfStats: async function(date) {
        return RestService.get(`${Config.get_store_shelf_stats}date=${date.format(format_without_time)}`, {})
        .then(response => response.json());
    },
    getStoreOutstandingLedger: async function(){
        return RestService.get(`${Config.report_store_outstanding}`, {})
        .then(response => response.json());
    },
    getIndentForAgent: async function(agent_id, date){
        return RestService.get(`${Config.get_indent_for_agent}agent_id=${agent_id}&date=${moment(date).format(format_without_time)}`, {})
        .then(response => response.json());
    },
    getScheduleStatusForStore: async function(store_id, startdate, enddate){
        return RestService.get(`${Config.check_schedule_exists}store_id=${store_id}&startdate=${moment(startdate).startOf('day').format(format)}&enddate=${moment(enddate).startOf('day').format(format)}`, {})
        .then(response => response.json());
    },
    getDailyDeliveryReport: async function(startdate, enddate){
        return RestService.get(`${Config.report_daily_delivery_status}startdate=${startdate.format(format_without_time)}&enddate=${enddate.format(format_without_time)}&action=download`, {});
    },
    updateGRN: async (transaction_id, grn) => {
        return RestService.get(`${Config.update_delivery_grn}transaction_id=${transaction_id}&grn=${grn}`, {});
    },

    getStateDeliveryCount: async function(state, startdate, enddate) {
        return RestService.get(`${Config.total_count}states=${state}&startdate=${moment(startdate).startOf('day').format(format)}&enddate=${moment(enddate).startOf('day').format(format)}&data_type=STATE_DELIVERY`, {})
        .then(response => response.json());
    },
    getStateDelivery: async function(state, startdate, enddate, from = 0, offset = 20) {
        return RestService.get(`${Config.get_statewise_delivery}states=${state}&startdate=${moment(startdate).startOf('day').format(format)}&enddate=${moment(enddate).startOf('day').format(format)}&from=${from}&offset=${offset}`, {})
        .then(response => response.json());
    },
};